import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';

export class FilterCode extends React.Component<FilterCommonProps, {}> {

  public render() {
    const {
      filterDomain,
      optionsEndpoint,
      optionsParams,
      simpleFormComponent: SimpleForm,
      initialValue,
      translation,
      filterDomain: { id: name },
      categoryOptionsEndpoint,
      displayCategories,
      categoryOptionsParams
    } = this.props;

    return <SimpleForm
      name={name}
      type={FIELD_TYPE.SELECT_MULTIPLE}
      initialValue={initialValue}
      optionsEndpoint={optionsEndpoint}
      categoryOptionsEndpoint={categoryOptionsEndpoint}
      placeholder={translation && translation.filters_search_placeholder}
      translation={translation}
      optionsParams={optionsParams}
      initiallyShowLongDescription={false}
      searchRequired={filterDomain.searchRequired}
      displayDisabledLabel={filterDomain.hasDisabledColumn && translation.include_disabled}
      hasDisabledColumn={filterDomain.hasDisabledColumn}
      displayCategories={displayCategories}
      categoryOptionsParams={categoryOptionsParams}
    />;
  }
}
